"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Wraps a function to create a curried argument that can be passed optionally.
 *
 * @param optionalParamType {string} The type of the optional parameter. If the wrapped function
 * recieves an argument of this type, it will return a new function that can be called to pass
 * the other arguments. If it doesn't match, the optional argument is considered undefined and
 * the inner function `fn` is executed immediately with undefined as the first argument.
 * @param fn A function that will receive the optional curried argument in the first parameter.
 * @returns {Function}
 *
 * @example
 * const test = optionalParamCurried(
 *   'string',
 *   (opt, a, b) => console.log({ opt, a, b })
 * );
 *
 * // intended usage:
 * test('abc')(1, 2); // logs { opt: 'abc', a: 1, b: 2 }
 * test(123, 456); // logs { opt: undefined, a: 123, b: 456 }
 *
 * // incorrect usage:
 * test(1, 2, 3); // redundant 3rd argument. logs { opt: undefined, a: 1, b: 2 }
 * test('abc', 1, 2); // does nothing (returns function)
 *
 */
var optionalParamCurried = function optionalParamCurried(optionalParamType, fn) {
  return function (firstArg) {
    // eslint-disable-next-line valid-typeof
    if (_typeof(firstArg) === optionalParamType) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return fn.apply(void 0, [firstArg].concat(args));
      };
    }

    for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      restArgs[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, [undefined, firstArg].concat(restArgs));
  };
};

var _default = optionalParamCurried;
exports.default = _default;